// Also used as the panel block's own inner-blocks template, so a panel added
// on its own matches the ones this block seeds.
export const PANEL_INNER_TEMPLATE = [
	[
		'core/group',
		{
			style: {
				border: {
					radius: {
						topLeft: '6px',
						topRight: '6px',
						bottomLeft: '6px',
						bottomRight: '6px',
					},
				},
				elements: {
					link: {
						color: {
							text: 'var:preset|color|brandy-primary',
						},
					},
				},
			},
			backgroundColor: 'white',
			textColor: 'brandy-primary',
			layout: { type: 'constrained', justifyContent: 'center' },
		},
		[
			[
				'core/heading',
				{
					align: 'center',
					level: 3,
					content: 'Heading',
					style: {
						typography: {
							textAlign: 'center',
						}
					}
				},
			],
			[
				'core/paragraph',
				{
					align: 'center',
					content: 'Content',
					style: {
						typography: {
							textAlign: 'center',
						}
					}
				},
			],
		],
	],
];

const DEFAULT_IMAGES = [
	'https://images.wpbrandy.com/uploads/skateboards-post-img-1.webp',
	'https://images.wpbrandy.com/uploads/skateboards-post-img-2.webp',
	'https://images.wpbrandy.com/uploads/skateboards-post-img-3.webp',
	'https://images.wpbrandy.com/uploads/skateboards-cat-img-2.webp',
];

export const TEMPLATE = DEFAULT_IMAGES.map( ( url ) => [
	'brandy/accordion-image-panel',
	{ imageUrl: url },
	PANEL_INNER_TEMPLATE,
] );
